(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired6e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired6e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d9qpM", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $99309b09ea75a8ac$export$6503ec6e8aabbaf; }, function (v) { return $99309b09ea75a8ac$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $99309b09ea75a8ac$export$f7ad0328861e2f03; }, function (v) { return $99309b09ea75a8ac$export$f7ad0328861e2f03 = v; });
var $99309b09ea75a8ac$export$6503ec6e8aabbaf;
var $99309b09ea75a8ac$export$f7ad0328861e2f03;
"use strict";
var $99309b09ea75a8ac$var$mapping = new Map();
function $99309b09ea75a8ac$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$99309b09ea75a8ac$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $99309b09ea75a8ac$var$resolve(id) {
    var resolved = $99309b09ea75a8ac$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$99309b09ea75a8ac$export$6503ec6e8aabbaf = $99309b09ea75a8ac$var$register;
$99309b09ea75a8ac$export$f7ad0328861e2f03 = $99309b09ea75a8ac$var$resolve;

});

parcelRegister("2czkw", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $19a81b8f44327b45$export$bdfd709ae4826697; }, function (v) { return $19a81b8f44327b45$export$bdfd709ae4826697 = v; });
var $19a81b8f44327b45$export$bdfd709ae4826697;
var $19a81b8f44327b45$export$c9e73fbda7da57b6;
var $19a81b8f44327b45$export$5a759dc7a1cfb72a;
"use strict";
var $19a81b8f44327b45$var$bundleURL = {};
function $19a81b8f44327b45$var$getBundleURLCached(id) {
    var value = $19a81b8f44327b45$var$bundleURL[id];
    if (!value) {
        value = $19a81b8f44327b45$var$getBundleURL();
        $19a81b8f44327b45$var$bundleURL[id] = value;
    }
    return value;
}
function $19a81b8f44327b45$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $19a81b8f44327b45$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $19a81b8f44327b45$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $19a81b8f44327b45$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$19a81b8f44327b45$export$bdfd709ae4826697 = $19a81b8f44327b45$var$getBundleURLCached;
$19a81b8f44327b45$export$c9e73fbda7da57b6 = $19a81b8f44327b45$var$getBaseURL;
$19a81b8f44327b45$export$5a759dc7a1cfb72a = $19a81b8f44327b45$var$getOrigin;

});

parcelRegister("kbETv", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bxDyF"))((parcelRequire("d9qpM")).resolve("8nemd")),
    (parcelRequire("bxDyF"))((parcelRequire("d9qpM")).resolve("fNgQB"))
]).then(function() {
    return parcelRequire("dt2kA");
});

});
parcelRegister("bxDyF", function(module, exports) {
"use strict";

var $8BlyI = parcelRequire("8BlyI");
module.exports = $8BlyI(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("8BlyI", function(module, exports) {
"use strict";
var $643280953e4fd376$var$cachedBundles = {};
var $643280953e4fd376$var$cachedPreloads = {};
var $643280953e4fd376$var$cachedPrefetches = {};
function $643280953e4fd376$var$getCache(type) {
    switch(type){
        case "preload":
            return $643280953e4fd376$var$cachedPreloads;
        case "prefetch":
            return $643280953e4fd376$var$cachedPrefetches;
        default:
            return $643280953e4fd376$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $643280953e4fd376$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $32e8498e71f340c5$exports = {};


(parcelRequire("d9qpM")).register((parcelRequire("2czkw")).getBundleURL("6Ibaz"), JSON.parse('["6Ibaz","page-digital-highlights-single.js","fNgQB","../../../../splide.3d55fd9e.js","8nemd","../../../../splide.3a80d7d7.js"]'));


(parcelRequire("kbETv")).then(function(param) {
    var Splide = param.Splide;
    // Variables
    setTimeout(function() {
        var sliders = document.querySelectorAll(".page-digital-highlights-single .splide");
        var tables = document.querySelectorAll(".ghm-table-wrapper");
        // Initializing Splider
        for(var i = 0; i < sliders.length; i++){
            var slider = new Splide(sliders[i], {
                type: "slide",
                gap: "3.375rem",
                padding: "4.25rem",
                pagination: false,
                focus: "center",
                rewind: true,
                breakpoints: {
                    1023: {
                        gap: "2rem",
                        padding: "3.5rem"
                    },
                    767: {
                        gap: "1.5rem",
                        padding: "2rem"
                    }
                }
            }).mount();
        // if(tables) {
        // 	tables.forEach(table => {
        // 		let links = table.querySelectorAll("a")
        // 		let slideImages = document.querySelectorAll(".splide__slide img")
        // 		let slideUrls = []
        // 		slideImages.forEach((image, i) => {
        // 			slideUrls[i] = image.src
        // 		})
        // 		links.forEach(link => {
        // 			link.addEventListener('click', function(e) {
        // 				e.preventDefault()
        // 				let url = e.target.href
        // 				let index = slideUrls.indexOf(url)
        // 				console.log(url)
        // 				console.log(index)
        // 				if( index != '-1' ) {
        // 					document.getElementById('gallery').scrollIntoView()
        // 					slider.move(index)
        // 				}
        // 			})
        // 		})
        // 	})
        // }
        }
    }, 1000);
});

})();
//# sourceMappingURL=page-digital-highlights-single.js.map
